import { createClient } from "smtpexpress"
import { useState } from "react";
export default function useDemoInfo({ values }) {

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] =useState(false);
    

    async function submitDemoRequest(e, token) {

        e.persist();
        setLoading(true);
        setError(false);
        
        const body = {
            email: values.email,
            template_id: process.env.GATSBY_CBP_TEMPLATE_ID,
            "g-recaptcha-response": token,
            params: {
                name: values.username,
                phone: values.phone,
                company: values.company,
                magSize: values.itemCount,
                erp: values.erp,
                quantity: values.magCount,
            }
        };

        const emailSend = await fetch(process.env.GATSBY_CBP_ENDPOINT + "email/send", {
            method: "POST",
            headers: {
                'X-API-KEY': process.env.GATSBY_CBP_API_KEY,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
        });

        if (emailSend.ok) {
            setMessage('Dziękujemy za przesłanie zapytania. Skontaktujemy się w ciągu 48 godzin.');
            window.dataLayer?.push({
                event: 'inquiry-sent'
            });
        } else {
            setError(true);
            setMessage('Prosimy o kontakt poprzez email: kontakt@bizami.pl.');
        }
    }
        return {
            submitDemoRequest,
            loading,
            message,
            error,
        };
    
};